var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEyeOpen(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 20,
    viewBox: "0 0 24 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.9996 5.21387C4.82137 5.21387 1.80762 11.6692 1.80762 11.8032C1.80762 11.9371 4.82137 18.3924 11.9996 18.3924C19.1778 18.3924 22.1915 11.9371 22.1915 11.8032C22.1915 11.6692 19.1778 5.21387 11.9996 5.21387Z",
    stroke: "#09253C",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3.71778 8.96386L1.0459 6.29199",
    stroke: "#09253C",
    strokeWidth: 2,
    strokeLinecap: "square",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8.80201 5.68259L7.71289 2.15918",
    stroke: "#09253C",
    strokeWidth: 2,
    strokeLinecap: "square",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M20.2812 8.96386L22.953 6.29199",
    stroke: "#09253C",
    strokeWidth: 2,
    strokeLinecap: "square",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M15.1973 5.68259L16.2864 2.15918",
    stroke: "#09253C",
    strokeWidth: 2,
    strokeLinecap: "square",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M11.3349 14.7079C12.9389 15.0752 14.5369 14.0727 14.9042 12.4687C15.2715 10.8648 14.269 9.26673 12.665 8.89943C11.061 8.53213 9.46299 9.53465 9.09569 11.1386C8.72839 12.7426 9.73091 14.3406 11.3349 14.7079Z",
    stroke: "#09253C",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEyeOpen);
export default __webpack_public_path__ + "static/media/eye-open.7696f42e7825bf919d08b2c35dc91e09.svg";
export { ForwardRef as ReactComponent };